import styled from '@emotion/styled';
import { shouldForwardProps } from '../../helpers';

const StyledText = ({ ...props }) => {
  const { customPropsObj } = shouldForwardProps(props);

  const getFontSize = (size) => {
    const fontSizes = {
      h1: {
        fontSize: '1.5rem',
        fontWeight: '700',
      },
      h2: {
        fontSize: '1.25rem',
      },
      h3: {
        fontSize: '1.125rem',
        fontStyle: 'italic',
      },
      subHeading: {
        fontSize: '0.875rem',
        fontWeight: '700',
      },
    };

    return size ? fontSizes[size] : {};
  };

  const fontSize = getFontSize(props.size);

  return {
    margin: 0,
    ...fontSize,
    ...customPropsObj,
  };
};

export const Text = styled('p')(StyledText);
